/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeCommandListResponse,
  ApiEnvelopeExecuteCommandResponse,
  ExecuteCommandRequest,
  GetCommandsToExecuteRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type commandGetCommandsToExecuteResponse200 = {
  data: void
  status: 200
}

export type commandGetCommandsToExecuteResponseSuccess = (commandGetCommandsToExecuteResponse200) & {
  headers: Headers;
};
;

export type commandGetCommandsToExecuteResponse = (commandGetCommandsToExecuteResponseSuccess)

export const getCommandGetCommandsToExecuteUrl = () => {




  return `/api/Command/GetCommandsToExecute`
}

export const useCommandGetCommandsToExecuteHook = (): (getCommandsToExecuteRequest?: GetCommandsToExecuteRequest, options?: RequestInit) => Promise<commandGetCommandsToExecuteResponse> => {

      const customFetcher = useSfetchMutator();
      return (getCommandsToExecuteRequest?: GetCommandsToExecuteRequest, options?: RequestInit) => {

        return customFetcher(getCommandGetCommandsToExecuteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(getCommandsToExecuteRequest)
  }
);
      }
  }


export type commandExecuteCommandResponse200 = {
  data: ApiEnvelopeExecuteCommandResponse
  status: 200
}

export type commandExecuteCommandResponse400 = {
  data: ApiEnvelopeExecuteCommandResponse
  status: 400
}

export type commandExecuteCommandResponse401 = {
  data: ApiEnvelopeExecuteCommandResponse
  status: 401
}

export type commandExecuteCommandResponseSuccess = (commandExecuteCommandResponse200) & {
  headers: Headers;
};
export type commandExecuteCommandResponseError = (commandExecuteCommandResponse400 | commandExecuteCommandResponse401) & {
  headers: Headers;
};

export type commandExecuteCommandResponse = (commandExecuteCommandResponseSuccess | commandExecuteCommandResponseError)

export const getCommandExecuteCommandUrl = () => {




  return `/api/Command/ExecuteCommand`
}

export const useCommandExecuteCommandHook = (): (executeCommandRequest?: ExecuteCommandRequest, options?: RequestInit) => Promise<commandExecuteCommandResponse> => {

      const customFetcher = useSfetchMutator();
      return (executeCommandRequest?: ExecuteCommandRequest, options?: RequestInit) => {

        return customFetcher(getCommandExecuteCommandUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(executeCommandRequest)
  }
);
      }
  }


export type commandOutstandingCommandsResponse200 = {
  data: ApiEnvelopeCommandListResponse
  status: 200
}

export type commandOutstandingCommandsResponse400 = {
  data: ApiEnvelopeCommandListResponse
  status: 400
}

export type commandOutstandingCommandsResponse401 = {
  data: ApiEnvelopeCommandListResponse
  status: 401
}

export type commandOutstandingCommandsResponseSuccess = (commandOutstandingCommandsResponse200) & {
  headers: Headers;
};
export type commandOutstandingCommandsResponseError = (commandOutstandingCommandsResponse400 | commandOutstandingCommandsResponse401) & {
  headers: Headers;
};

export type commandOutstandingCommandsResponse = (commandOutstandingCommandsResponseSuccess | commandOutstandingCommandsResponseError)

export const getCommandOutstandingCommandsUrl = () => {




  return `/api/Command/OutstandingCommands`
}

export const useCommandOutstandingCommandsHook = (): ( options?: RequestInit) => Promise<commandOutstandingCommandsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getCommandOutstandingCommandsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


